import { Contenido } from './Contenido';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AlaFormulario } from './AlaFormulario';
import { NodoFormulario } from './NodoFormulario';

export class CoincidenciasLocalizacionContenidos {

	Contenido_1: Contenido;
	Contenido_2: Contenido;

	Titulo_1: String;
	Titulo_2: String;
	Seccion: String;

	// Datos del WS
	contenido_1: String; // Id
	desde_1: Date;
	hasta_1: Date;
	contenido_2: String; // Id
	desde_2: Date;
	hasta_2: Date;
	desde_max: Date;
	hasta_min: Date;
	tiempo_coincidencia: Number;

	Ala_Id: String; // Id
	Nivel_Id: String; // Id
	Nodo_Id: String; // Id
	Seccion_Id: String; // Id
	Nivel: string;
	Ala: string;
	Localizacion: string;

	constructor(){

	}

	fromENTIDAD(ENTIDAD: any): CoincidenciasLocalizacionContenidos{

		// Datos del WS
		this.contenido_1 =  ENTIDAD.contenido_1;
		this.desde_1 =  ENTIDAD.desde_1;
		this.hasta_1 =  ENTIDAD.hasta_1;
		this.contenido_2 =  ENTIDAD.contenido_2;
		this.desde_2 =  ENTIDAD.desde_2;
		this.hasta_2 =  ENTIDAD.hasta_2;
		this.desde_max =  ENTIDAD.desde_max;
		this.hasta_min =  ENTIDAD.hasta_min;
		this.tiempo_coincidencia =  ENTIDAD.tiempo_coincidencia; 

		this.Ala_Id =  ENTIDAD.Ala_Id; 
		this.Nivel_Id =  ENTIDAD.Nivel_Id; 
		this.Nodo_Id =  ENTIDAD.Nodo_Id; 
		this.Seccion_Id =  ENTIDAD.Seccion_Id; 

		return this;
	}

	rellenarContenido(cont_1: Contenido, cont_2: Contenido, seccion){

		this.Contenido_1 = cont_1;
		this.Contenido_2 = cont_2;
		this.Titulo_1 = cont_1.Titulo;
		this.Titulo_2 = cont_2.Titulo;
		this.Seccion = seccion.Nombre;
		this.Nivel = cont_1.Nivel;
		this.Ala = cont_1.Ala;
		this.Localizacion = this.Ala + ' ' + this.Nivel + ' ' + this.Seccion;

	}


}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/CoincidenciasLocalizacionContenidos.ts